<template>
  <div>
    <v-progress-linear v-if="loadingCharts" indeterminate color="primary" class="mb-4"></v-progress-linear>

    <v-card class="mb-4">
      <v-card-title>
        <h2>{{ dayChart.title }}</h2>
      </v-card-title>
      <v-card-text>
        <apexchart
          type="bar"
          height="320"
          :options="chartOptions(dayChart)"
          :series="dayChart.series"
        ></apexchart>
        <div v-if="!dayChart.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.week">
      <v-card-title>
        <h2>{{ weekChart.title }}</h2>
      </v-card-title>
      <v-card-text>
        <apexchart
          type="bar"
          height="320"
          :options="chartOptions(weekChart)"
          :series="weekChart.series"
        ></apexchart>
        <div v-if="!weekChart.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.month">
      <v-card-title>
        <h2>{{ monthChart.title }}</h2>
      </v-card-title>
      <v-card-text>
        <apexchart
          type="bar"
          height="320"
          :options="chartOptions(monthChart)"
          :series="monthChart.series"
        ></apexchart>
        <div v-if="!monthChart.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>

    <v-card class="mb-4" v-if="chartVisibility.year">
      <v-card-title>
        <h2>{{ yearChart.title }}</h2>
      </v-card-title>
      <v-card-text>
        <apexchart
          type="bar"
          height="320"
          :options="chartOptions(yearChart)"
          :series="yearChart.series"
        ></apexchart>
        <div v-if="!yearChart.hasData" class="mt-2">No data available for this period.</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
